module.exports = __webpack_public_path__ + "static/media/Paperclip.f882436b.svg";